import type { KeyboardEvent, ReactNode } from 'react';

import classNames from 'classnames';

import styles from './ToggleButton.module.css';

import { Minus } from '../../../icons/Minus';
import { Plus } from '../../../icons/Plus';
import { ButtonBase } from '../../ButtonBase';

interface ToggleButtonProps {
  id: string | undefined;
  children: ReactNode;
  sectionId: string | undefined;
  open: boolean;
  onClick: () => void;
  onKeyDown?: (e: KeyboardEvent<HTMLButtonElement>) => void;
}

export function ToggleButton(props: ToggleButtonProps) {
  const { id, sectionId, open, onClick, onKeyDown, children } = props;
  return (
    <ButtonBase
      type="button"
      onClick={onClick}
      onKeyDown={onKeyDown}
      className={classNames(styles.toggle)}
      aria-controls={sectionId}
      aria-expanded={open}
      id={id}
    >
      {children}
      <>
        {open ? (
          <Minus
            height={36}
            baseColor="Kale3"
            aria-label="Collapse accordion section"
          />
        ) : (
          <Plus
            height={36}
            baseColor="Kale3"
            aria-label="Expand accordion section"
          />
        )}
      </>
    </ButtonBase>
  );
}
